// extracted by mini-css-extract-plugin
export default {"container":"TagPage_container__UbcDq","textContainer":"TagPage_textContainer__RefZu","productCard":"TagPage_productCard__SEgtg"};